import { render, staticRenderFns } from "./on-account-manage.vue?vue&type=template&id=481d69c1&scoped=true&"
import script from "./on-account-manage.vue?vue&type=script&lang=ts&"
export * from "./on-account-manage.vue?vue&type=script&lang=ts&"
import style0 from "./on-account-manage.vue?vue&type=style&index=0&id=481d69c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d69c1",
  null
  
)

export default component.exports